<div class="mb-8">
  <app-form-title-with-subtitle>
    <span title>Zarejestruj się jako klient</span>
    <span subtitle>Załóż konto za darmo i zacznij korzystać z portalu</span>
  </app-form-title-with-subtitle>
</div>

<div class="mb-8">
  <app-alerts />

  @if (isFormVisible()) {
    <app-sign-up-as-client-form
      (submitClickEvent)="handleSubmitClickEvent($event)" />
  }
</div>

@if (isFormVisible()) {
  @if (shouldShowSocials()) {
    <div>
      <h2 class="text-xl font-medium">lub zaloguj się za pomocą:</h2>

      <div class="flex gap-3">
        <button (click)="handleSignUpByFacebookClick()">
          <app-social-icon [type]="SocialIconType.Facebook" />
        </button>

        <button (click)="handleSignUpByGoogleClick()">
          <app-social-icon [type]="SocialIconType.Google" />
        </button>
      </div>
    </div>
  }
} @else {
  <div class="mb-8 text-center">
    <p-button
      (onClick)="handleNavigateToSignInPageClick()"
      appPrimengButton
      label="Przejdź do strony logowania" />
  </div>
}
